<template>
  <div>
    <Loading :complete="loadComplete" :onRemoved="onLoadingIntroRemoved"></Loading>
    <Layout class="transparent" ref="pageRef">
      <template v-slot:navigation>
        <Navigation :showMenu="true">
          <!-- <template v-slot:title>Samsung Eco-Package</template> -->
          <template v-slot:title>
            <span class="title" @click="HomeLink()">
              Samsung Upcycle-Packaging
              <!-- {{ $t("LandingPage.title") }} -->
            </span>
          </template>
        </Navigation>
      </template>
      <template v-slot:content>
        <div class="content">
          <div class="content-sequence" ref="contentSequence">
            <LandingSequence :onLoadComplete="onLoadComplete">
              <div class="center" slot="down-arrow">
                <img src="../../assets/icons/down-arrowpc.png" class="pc-downarrow" />
                <img src="../../assets/icons/downarrow-1.png" class="arrow-down" />
              </div>
              <LandingCategoryList slot="category-list"></LandingCategoryList>
              <Footer slot="footer"></Footer>
            </LandingSequence>

            <!-- <div class="center"> -->
            <!-- <div class="arrow-down" /> -->
            <!-- <div class="arrow-mobile">
                <img alt="arrow" ref="arrow" src="../../assets/arrow_motion.gif" />
            </div>-->
            <!-- <div class="arrow-pc"></div> -->
            <!-- </div> -->
          </div>
          <!-- <LandingCategoryList /> -->
        </div>
      </template>
    </Layout>
  </div>
</template>

<script>
import { TweenMax } from "gsap";
import Layout from "../style/Layout.vue";
import Navigation from "../style/Navigation.vue";
import Footer from "../style/Footer.vue";
import LandingCategoryList from "../style/LandingCategoryList.vue";
import LandingSequence from "../style/LandingSequence.vue";
import Loading from "../style/Loading.vue";

export default {
  components: {
    Layout,
    Navigation,
    Footer,
    LandingCategoryList,
    LandingSequence,
    Loading,
  },
  data() {
    return {
      loadComplete: false,
      scrollY: 0,
      timer: null
    };
  },
  mounted() {
    this.$nextTick(() => {
       if(window.sessionStorage.getItem("introFlag")=='true')
     {window.scrollTo(0, 0);}
     else{
        let scrolly = window.sessionStorage.getItem("scrollY")
        window.top.scrollTo(0, scrolly);
     }
      // this.loadComplete = true;
      // console.log("is it call?", this.$refs.pageRef);
      // TweenMax.to(this.$refs.pageRef.$el, 0.0, { opacity: 0 });
      // TweenMax.to(this.$refs.pageRef.$el, 1.0, { opacity: 0 });
      // TweenMax.to(this.$refs.pageRef.$el, 1.6, { opacity: 1 });
    });
    
  },
  created(){
    // 핸들러 등록하기
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy: function () {
    // 핸들러 제거하기(컴포넌트 또는 SPA의 경우 절대 잊지 말아 주세요!)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    onLoadComplete(bool) {
      this.loadComplete = bool;
    },
    onLoadingIntroRemoved() {
      // window.top.scrollTo(0, 0);
      this.$refs.pageRef.$el.style.opacity = 0;

      TweenMax.to(this.$refs.pageRef.$el, 0.0, { opacity: 0 });
      TweenMax.to(this.$refs.pageRef.$el, 1.0, { opacity: 0 });
      TweenMax.to(this.$refs.pageRef.$el, 1.6, {
        opacity: 1,
        onComplete() {
          document.body.style.overflowY = "auto";
        },
      });
      // onComplete: () => {}
      // window.top.scrollTo(0, scrolly);
    },
    HomeLink(){
      window.sessionStorage.setItem("introFlag", true)
      window.location.reload();
    },
     handleScroll() {
      if (this.timer === null) {
        this.timer = setTimeout(function () {
          this.scrollY = window.scrollY
          window.sessionStorage.setItem("scrollY", this.scrollY)
          clearTimeout(this.timer)
          this.timer = null
        }.bind(this), 200)
      }
    }
  },
};
</script>

<style scoped>
.title{
  cursor: pointer;
}
.transparent {
  opacity: 0;
  background-color: black;
}
.landing_sequence_wrapper {
  display: flex;
  justify-content: space-between;
}
.content {
  width: 100%;
  background: black;
}
.landing-image {
  width: 800px;
  margin-left: 0;
  /* margin-top: 25vh; */
}
.landing-text {
  width: 40%;
  /* display: flex; */
  /* justify-content: flex-end; */
}

.content-sequence {
  height: auto;
  min-height: 100vh;
  /* height: 700vh; */
}
.center {
  text-align: center;
  display: flex;
  justify-content: center;
}

.tween-text {
  position: relative;
  top: 50vh;

  color: white;
}
.tween-text-title {
  color: white;
  /* opacity: 0; */
}
.tween-text-subtitle {
  color: white;
  /* opacity: 0; */
}
/* .arrow-down {
    position: relative;
    width: 40px;
    height: 40px;
    margin-bottom: 20px;
  } */
.arrow-down::after {
  position: absolute;
  content: " ";
  width: 30px;
  height: 30px;
  border-bottom: 2px solid #f5f5f5;
  border-left: 2px solid #f5f5f5;
  transform: translate(-50%, -50%) rotate(-45deg);
  top: 50%;
  left: 50%;
}
.pc-downarrow {
  margin-bottom: 20px;
  display: inline-block;
}
.arrow-down {
  display: none;
}
@media (max-width: 1024px) {
  .pc-downarrow {
    display: none;
  }
  .title {
    font-weight: 700;
  }
  .arrow-down {
    /* width: 15px;
    height: 15px;
     */
    display: inline-block;
    margin-bottom: 20px;
  }
}

/* .content {

  height: 500vh;
} */
</style>
